import authHelper from 'src/api/auth/helper';
import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';

authService.$inject = [
  'jsSdk.auth',
  'jsSdk.AUTH_TYPES',
  'cacheService',
  'jsSdk.config',
  'jsSdk.cookie',
  'TRACKING_EVENT_CATEGORIES',
  'analyticsService',
  'permissionService',
  'venueService',
  'managementUserOrganizationMemberService',
  'userPreferencesService',
  'organizationRelationshipService'
];

export default function authService(sdkAuthService, AUTH_TYPES, cacheService, sdkConfig, sdkCookie, TRACKING_EVENT_CATEGORIES, analyticsService, permissionService, venueService, organizationMemberService, userPreferencesService, organizationRelationshipService) { //eslint-disable-line
  class AuthService {
    logout() { //eslint-disable-line
      analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.LOGGED_OUT);

      cacheService.clear();

      venueService.clear();

      organizationRelationshipService.clear();

      organizationMemberService.clear();

      permissionService.clearPermissions();

      authHelper.removeAuthToken();

      _clearAuth();
    }
  }

  function _clearAuth() {
    sdkAuthService.logout({
      type: AUTH_TYPES.MANAGEMENT
    });

    sdkAuthService.logout({
      type: AUTH_TYPES.CONSUMER
    });

    const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';

    sdkCookie.remove(sdkConfig.consumerAuthTokenKey, {
      domain: true,
      secure: true,
      expires
    });

    sdkCookie.remove(sdkConfig.consumerAuthTokenKey, {
      domain: false,
      secure: false,
      expires
    });

    sdkCookie.remove(sdkConfig.managementAuthTokenKey, {
      domain: true,
      secure: true,
      expires
    });

    sdkCookie.remove(sdkConfig.managementAuthTokenKey, {
      domain: false,
      secure: false,
      expires
    });

    userPreferencesService.setManageCalendarDate(null);
  }

  return new AuthService();
}



// WEBPACK FOOTER //
// ./src/services/authService.js